import AbstractApi from './abstract';
import { 
  AtcApi,
  AuthApi,
  CertificateApi,
  FlyingListApi,
  OrderApi,
  PagesApi,
  PaymentApi,
  ReportsApi,
  ServicesApi,
  TariffApi,
  TaskApi,
  UserApi
} from './domains';
import { apiInterface } from './interfaces';

class Api extends AbstractApi {
  auth: apiInterface.IAuthApi

  certificate: apiInterface.ICertificateApi

  order: apiInterface.IOrderApi

  page: apiInterface.IPagesApi

  payment: apiInterface.IPaymentApi

  reports: apiInterface.IReportsApi

  services: apiInterface.IServicesApi

  tariff: apiInterface.ITariffApi

  task: apiInterface.ITaskApi

  user: apiInterface.IUserApi

  atc: apiInterface.IAtcApi

  flyingList: apiInterface.IFlyingListApi

  constructor (MAIN_URL: string) {
    super(MAIN_URL)
    this.auth = new AuthApi(this)
    this.certificate = new CertificateApi(this)
    this.order = new OrderApi(this)
    this.page = new PagesApi(this)
    this.payment = new PaymentApi(this)
    this.reports = new ReportsApi(this)
    this.services = new ServicesApi(this)
    this.tariff = new TariffApi(this)
    this.task = new TaskApi(this)
    this.user = new UserApi(this)
    this.atc = new AtcApi(this)
    this.flyingList = new FlyingListApi(this)
  }
}

const URL = process.env.REACT_APP_API_URL || ''

const api = new Api(URL)

export { Api, api }
